// @flow
import * as React from 'react'

const Page = () => {
  return <div>Not Found Page</div>
}

export default Page
